var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#89959c",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M20.587 10.522c0 4.878-4.29 8.83-9.584 8.83-1.181 0-2.312-.196-3.357-.556L2.138 21.69l2.157-4.862C2.52 15.224 1.42 12.992 1.42 10.522c0-4.879 4.29-8.832 9.583-8.832 5.294 0 9.584 3.953 9.584 8.832z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#89959c",
    d: "M11 7a1 1 0 100-2 1 1 0 000 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#89959c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    d: "M11.427 14.05V9.14H9.76m0 4.91h3.333"
  })));
}

export default SvgHelpCenter;